<template>
  <v-btn class="ma-0" small color="black" fab :href="fullscreenViewerUrl">
    <fullScreenIcon :class="[$style.buttonIconPosition, $style.iconImageStyle]">
    </fullScreenIcon>
  </v-btn>
</template>

<script>
import fullScreenIcon from "./assets/fullscreen_icon.svg";

export default {
  name: "vc-share-fullscreen-button",
  components: {
    fullScreenIcon
  },
  props: {
    fullscreenViewerUrl: {
      type: String,
      default: null
    }
  }
};
</script>

<style module>
.iconImageStyle {
  height: 34px;
  width: 34px;
  object-fit: contain;
}

.buttonIconPosition {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
